export namespace NavLocationAreas {

  export enum Generic {
    unknown = 'unknown'
  }

  export enum SiteContent {
    home = 'home',
    metrics = 'metrics',
    metric_detail = 'metric_detail',
    predictive_model_editor = 'predictive_model_editor',
    search = 'search',
    explore = 'explore',
    favorites = 'favorites',
    recents = 'recents',
    recommendations = 'recommendations',
    catalog = 'catalog',
    site_viz = 'site_viz',
    usage_analytics = 'usage_analytics',
    site_unspecified = 'site_unspecified',
    collections = 'collections',
    shared_with_me = 'shared_with_me',
    personal_space = 'personal_space',
  }

  export enum SiteAdmin {
    site_users = 'site_users',
    site_groups = 'site_groups',
    site_broadcasts = 'site_broadcasts',
    site_schedules = 'site_schedules',
    site_tasks = 'site_tasks',
    site_status = 'site_status',
    site_settings = 'site_settings',
    site_jobs = 'site_jobs',
    site_viz = 'site_admin_viz'
  }

  export enum ServerAdmin {
    server_schedules = 'server_schedules',
    server_users = 'server_users',
    server_settings = 'server_settings',
    server_sites = 'server_sites',
    server_status = 'server_status',
    server_jobs = 'server_jobs',
    server_tasks = 'server_tasks',
    server_viz = 'server_viz',
    server_unspecified = 'server_unspecified',
  }
}

export type NavLocationAreaEnum = (typeof NavLocationAreas)[keyof typeof NavLocationAreas];

export function isNavLocationInAreas(location: NavLocation, ...areaEnums: NavLocationAreaEnum[]): boolean {
  return areaEnums.some(area => area.hasOwnProperty(location));
}

// Displaying breadcrumbs is opt-in. In order to display breadcrumbs on the page header for
// a nav location, it must be in the list below and the UI code must properly update breadcrumbs redux store
// using the updateBreadCrumbs action.
const displayBreadcrumbsOnNavLocations: NavLocation[] = [
  NavLocationAreas.SiteContent.explore,
  NavLocationAreas.SiteContent.catalog,
  NavLocationAreas.SiteContent.site_viz,
  NavLocationAreas.SiteContent.metric_detail,
  NavLocationAreas.SiteContent.predictive_model_editor,
  NavLocationAreas.SiteContent.usage_analytics,
  NavLocationAreas.SiteContent.personal_space,
  NavLocationAreas.SiteAdmin.site_users,
  NavLocationAreas.SiteAdmin.site_groups,
  NavLocationAreas.SiteAdmin.site_schedules,
  NavLocationAreas.SiteAdmin.site_viz,
  NavLocationAreas.ServerAdmin.server_schedules,
  NavLocationAreas.ServerAdmin.server_users,
  NavLocationAreas.ServerAdmin.server_viz,
];
export function displayBreadcrumbsForNavLocation(location: NavLocation): boolean {
  return displayBreadcrumbsOnNavLocations.includes(location);
}

export type NavLocation =
  NavLocationAreas.Generic |
  NavLocationAreas.SiteContent |
  NavLocationAreas.SiteAdmin |
  NavLocationAreas.ServerAdmin;
